import Styled from "styled-components";
import Button from "./Button";

export const OutlineButton = Styled(Button).attrs(props => ({
  to: props.to
}))`
  && {
    background-color: white;
    color: ${props => props.theme.palette.primary["500"]};
    box-sizing: border-box;
    border: 1px solid #4b5f78;
    font-weight: 600;
    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
